import FullTable      from 'js/components/full-table/index.js'
import AnalyticsUtils from 'js/services/analytics-utils'
import template       from './_table.pug'
 
export default Vue.extend({
  template: template(),
  components: { FullTable },
  props: {
    leads:    { type: Array,  required: true },
    meta:     { type: Object, required: true },
    autoLoad: { type: Boolean, default: false }
  },

  data() {
    return {
       dateConfig: {
        dateFormat: 'd/m/Y',
        allowInvalidPreload: true,
        enableTime: false
      },
      showFilters: true,
      search:      '',
      filters: {
        from:   '',
        to:     '',
        leadId:     '',
        phone:      '',
        customerId: '',
        campaignId: '',
        providerId: '',
        statusLead: '',
        cta:        ''
      },
      selectedColumns: [
        'leadId','createdAt','phone','leadCTIId','firstName','secondName',
        'email','campaign','state','callCenter','customer','provider',
        'category','cta','service','statusCTI','utmSource','utmCampaign',
        'utmMedium','leadSourceId','visitorId','fullName','agentId',
        'agentName','agentType','agentSupervisor','agentProvince',
        'agentProducts','formProvider'
      ],

      showColumnsMenu: false,

      columnFlag: {},

      customersOptions: [],
      campaignsOptions: [],
      providersOptions: [],
      statusOptions: [],
      ctaOptions: [
        { value:'Form',    label:'Form'    },
        { value:'Inbound', label:'Inbound' }
      ]
    }
  },

  computed: {
    internalAutoLoad: {
      get()  { return this.autoLoad },
      set(v) { this.$emit('update:autoLoad', v) }
    },

    filterButtonParams() {
      return {
        class: this.showFilters ? 'active' : '',
        icon:  this.showFilters ? 'angle-up' : 'angle-down'
      }
    },

    allColumns() {
      const fromI18n = Object.entries(this.$t('leads.index.columns'))
        .map(([key,label]) => ({ key,label }))
      const manual = [
        { key:'leadId',        label:this.$t('leads.index.columns.leadId') },
        { key:'createdAt',     label:this.$t('leads.index.columns.createdAt') },
        { key:'phone',         label:this.$t('leads.index.columns.phone') },
        { key:'leadCTIId',     label:this.$t('leads.index.columns.leadCTIId') },
        { key:'firstName',     label:this.$t('leads.index.columns.firstName') },
        { key:'secondName',    label:this.$t('leads.index.columns.secondName') },
        { key:'email',         label:this.$t('leads.index.columns.email') },
        { key:'campaign',      label:this.$t('leads.index.columns.campaign') },
        { key:'state',         label:this.$t('leads.index.columns.state') },
        { key:'callCenter',    label:this.$t('leads.index.columns.callCenter') },
        { key:'customer',      label:this.$t('leads.index.columns.customer') },
        { key:'provider',      label:this.$t('leads.index.columns.provider') },
        { key:'category',      label:this.$t('leads.index.columns.category') },
        { key:'cta',           label:this.$t('leads.index.columns.cta') },
        { key:'service',       label:this.$t('leads.index.columns.service') },
        { key:'statusCTI',     label:this.$t('leads.index.columns.statusCTI') },
        { key:'utmSource',     label:this.$t('leads.index.columns.utmSource') },
        { key:'utmCampaign',   label:this.$t('leads.index.columns.utmCampaign') },
        { key:'utmMedium',     label:this.$t('leads.index.columns.utmMedium') },
        { key:'leadSourceId',  label:this.$t('leads.index.columns.leadSourceId') },
        { key:'visitorId',     label:this.$t('leads.index.columns.visitorId') },
        { key:'fullName',      label:this.$t('leads.index.columns.fullName') },
        { key:'agentId',       label:this.$t('leads.index.columns.agentId') },
        { key:'agentName',     label:this.$t('leads.index.columns.agentName') },
        { key:'agentType',     label:this.$t('leads.index.columns.agentType') },
        { key:'agentSupervisor', label:this.$t('leads.index.columns.agentSupervisor') },
        { key:'agentProvince', label:this.$t('leads.index.columns.agentProvince') },
        { key:'agentProducts', label:this.$t('leads.index.columns.agentProducts') },
        { key:'formProvider',  label:this.$t('leads.index.columns.formProvider') }
      ]
      const seen = new Set()
      return [...fromI18n, ...manual].filter(col => {
        if (seen.has(col.key)) return false
        seen.add(col.key)
        return true
      })
    },
    visibleColumns() {
      return this.allColumns.filter(c =>
        this.selectedColumns.includes(c.key)
      )
    },
    fromDateConfig() {
      return {
        ...this.dateConfig
      }
    },
    toDateConfig() {
      return {
        ...this.dateConfig
      }
    },
    defaultOrder() {
      return { currentField:'createdAt', currentDir:'desc' }
    },
    filteredLeads() {
      const term = this.search.toLowerCase()
   
      return this.leads
        .filter(l => {
          if (!term) return true
          return Object.values(l).some(v =>
            String(v).toLowerCase().includes(term)
          )
        })
        .filter(l => {
          const d = new Date(l.date)
          if (this.filters.from && this.parseDMY(this.filters.from) > d) return false;
          if (this.filters.to   && this.parseDMY(this.filters.to)   < d) return false;
          return true
        })
        /*.filter(l => {
          if (this.filters.leadId      && !String(l.leadId      ).includes(this.filters.leadId))      return false
          if (this.filters.phone       && !String(l.phone       ).includes(this.filters.phone))       return false
          if (this.filters.customerId  && l.customerId   !== this.filters.customerId)                 return false
          if (this.filters.campaignId  && l.campaignId   !== this.filters.campaignId)                 return false
          if (this.filters.providerId  && l.providerId   !== this.filters.providerId)                 return false
          if (this.filters.statusLead  && l.state        !== this.filters.statusLead)                 return false
          if (this.filters.cta         && l.ctaType      !== this.filters.cta)                        return false
          return true
        })*/
    }
  },

  created() {
    API.customers.index({ order:{ name:'asc' }, page:{ number:1, size:1000 } })
      .then(({ data }) => this.customersOptions = data.map(c => ({ value:c.id, label:c.name })))
    API.campaigns.index({ simplequery:1, order:{ name:'asc' }, page:{ number:1, size:1000 } })
      .then(({ data }) => this.campaignsOptions = data.map(c => ({ value:c.id, label:c.name })))
    API.providerLeads.index({ page:{ number:1, size:1000 } })
      .then(({ data }) => this.providersOptions = data.map(p => ({ value:p.id, label:p.name })))
    API.constants.index().then(({ data }) => {
      this.statusOptions = data.statusLeads.map(s => ({ value:s.key, label:s.name }))
    })
  },

  methods: {
    getData(opts = {}) {      
      this.$emit('load-data', opts)
    },
    applySearch() {
      const size = this.meta.page?.size || 100
      this.getData({ filter:{ search:this.search }, page:{ number:1, size } })
      //this.getData({ filter:{ search:this.search, ...this.filters }, page:{ number:1, size },order: { createdAt: 'desc' } })
    },
    clearSearch() {
      this.search = ''
      this.applySearch()
    },
    parseDMY(dateStr) {
    if (!dateStr) return null; // Evita errores si viene null o undefined
    
    // Si es un objeto Date, lo convertimos a string en formato dd/mm/yyyy
    if (dateStr instanceof Date) {
        const day = String(dateStr.getDate()).padStart(2, '0');
        const month = String(dateStr.getMonth() + 1).padStart(2, '0');
        const year = dateStr.getFullYear();
        return new Date(year, month - 1, day);
    }

    // Si ya es string
    if (typeof dateStr === 'string') {
        const [day, month, year] = dateStr.split('/');
        return new Date(year, month - 1, day);
    }

    // Si es cualquier otro tipo, devolvemos null
    return null;
},
   setQuickRange(key) {
  const today = new Date();

  // Función para formatear siempre a dd/mm/yyyy
  const formatDate = (d) => {
    const day   = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year  = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  let from = null;
  let to = null;

  // Usar nuevas instancias de Date para no modificar `today`
  switch (key) {
    case 'today':
      from = new Date(today);
      to = new Date(today);
      break;
    case 'yesterday':
      from = new Date(today);
      from.setDate(from.getDate() - 1);
      to = new Date(from);
      break;
    case 'last7Days':
      from = new Date(today);
      from.setDate(from.getDate() - 6);
      to = new Date(today);
      break;
    case 'last30Days':
      from = new Date(today);
      from.setDate(from.getDate() - 29);
      to = new Date(today);
      break;
    case 'thisMonth':
      from = new Date(today.getFullYear(), today.getMonth(), 1);
      to = new Date(today);
      break;
    case 'allTime':
      from = null;
      to = null;
      break;
  }

  // Asignar como string o vacío
  this.filters.from = from ? formatDate(from) : '';
  this.filters.to   = to   ? formatDate(to)   : '';

  // Verificar en consola
  console.log('from:', this.filters.from, typeof this.filters.from);
  console.log('to:', this.filters.to, typeof this.filters.to);
}

,
    applyFilters() {
      const size = this.meta.page?.size || 100        
     const formatDate = (d) => {
    if (!d) return '';
    if (typeof d === 'string') return d;
    const day   = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year  = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const filtersToSend = {
    ...this.filters,
    from: formatDate(this.filters.from),
    to:   formatDate(this.filters.to)
  };

  console.log('Filtros a enviar:', filtersToSend);
        this.getData({
        filter: { search: this.search, ...filtersToSend  },
        page: { number: 1, size },
        order: { createdAt: 'desc' }
      });
    },
    resetFilters() {
      Object.keys(this.filters).forEach(k => this.filters[k] = '')
      //this.applyFilters()
    },
    exportLeads() {
      API.accounts.leadsViewCvs(this.$user.accountId, {
        filter:{ search:this.search, ...this.filters }
      }).then(({ data }) => {
        AnalyticsUtils.downloadCsv({
          title: this.$t('leads.index.export'),
          url: data.file
        })
      })
    },
    formatDate(date) {
      const d = new Date(date)
      return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`
    },
    toggleColumn(key) {
      const idx = this.selectedColumns.indexOf(key)
      if (idx >= 0) {
        this.selectedColumns.splice(idx, 1)
      } else {
        this.selectedColumns.push(key)
      }
    },
    toggleColumnsMenu() {
      this.showColumnsMenu = !this.showColumnsMenu
      if (this.showColumnsMenu) {
        this.showAllColumns = false
      }
    },
      toggleShowAllColumns() {
        this.showAllColumns = !this.showAllColumns
    },
     handleInternalScroll(e) {
    this.$emit('scroll-leads', e); // Emitir al padre
  }
  },

    watch: {
      columnFlag: {
        deep: true,
        handler(flags) {
          this.selectedColumns = Object
            .entries(flags)
            .filter(([key, isOn]) => isOn)
            .map(([key]) => key)
        }
      }
  },

  mounted() {
    if (this.autoLoad) this._i = setInterval(this.applyFilters, 10000)
  this.allColumns.forEach(col => {
    this.$set(this.columnFlag, col.key, this.selectedColumns.includes(col.key))
  })

  const el = this.$refs.scrollContainer;
  if (el) {
    el.addEventListener('scroll', this.handleInternalScroll);
  }

  const table = this.$el.querySelector('#leads_table table');
  if (table) {
    table.classList.add('leads_table_account');
  }
  },

  beforeDestroy() {
    clearInterval(this._i)
    const el = this.$refs.scrollContainer;
    if (el) {
      el.removeEventListener('scroll', this.handleInternalScroll);
    }
  }
})
